import { createComponent } from '@mtfe/sweet';
import { common, dom, eventBus } from '@mtfe/sweet-utils';
import tpl from './dom.html';
import style from './style.less';
import componentUtils from '../utils/index';
import { COUPON_STATUS } from '../constants/index';

const { getGiftEventName, Describe } = componentUtils;
const { isFunction, createUniqueId } = common;
// 点击立即领取
const defaultTitle = '大额外卖红包';
const defaultSubTitle = '部分商家可用';
const defaultAfterGetBtnText = '去使用';
const defaultGetBtnTxt = '立即领取';

const btnID = createUniqueId();

const changeBtnText = (text) => {
    const btnDom = dom.$id(btnID);
    btnDom.innerText = text;
};

const COMPONENT_ID = 'waimai_tpoymln0';
const SUB_COMPONENT_USE_ID = 'waimai_hnermtii';
const SUB_COMPONENT_RECEIVE_ID = 'waimai_24aqbfbs';

const describeRedBagAreaA = new Describe('RedBagAreaA', COMPONENT_ID);
const describeReceive = new Describe('Receive', SUB_COMPONENT_RECEIVE_ID);
const describeUse = new Describe('Use', SUB_COMPONENT_USE_ID);

describeRedBagAreaA.setSubComponent('Receive', describeReceive);
describeRedBagAreaA.setSubComponent('Use', describeUse);

/**
 * 领取红包区域
 * @param {object} props
 * @param {object} giftInfo 红包参数
 * @param {string} [props.title='大额外卖红包'] 红包主标题
 * @param {string} [props.subtitle='部分商家可用'] 红包副标题
 * @param {String} [props.afterGetBtnText='去使用'] 获取红包后文案
 * @param {String} [props.getBtnTxt='立即领取'] 获取红包文案
 * @param {function} [props.onClickBtn] 点击按钮回调
 * @returns
 */
const RedBagAreaA = (props = {}) => {
    const {
        giftInfo,
        title = defaultTitle,
        subtitle = defaultSubTitle,
        afterGetBtnText = defaultAfterGetBtnText,
        getBtnTxt = defaultGetBtnTxt,
        onClickBtn = () => {},
    } = props;

    let { coupon_amount: value, order_amount_limit: threshold, status, gift_id: giftId } = giftInfo;
    const canReceive = status === COUPON_STATUS.STATUS_NEW;

    value = value / 100;
    threshold = threshold / 100;
    if (value === undefined) {
        throw new Error('RedBagAreaA Error: The parameter value is missing.');
    }
    if (threshold === undefined) {
        throw new Error('RedBagAreaA Error: The parameter threshold is missing.');
    }
    const events = {
        onClickReceive: async () => {
            if (isFunction(onClickBtn)) {
                try {
                    await onClickBtn();
                } catch (error) {
                    console.error(error);
                }
            }
        },
    };
    const eventName = getGiftEventName(giftId);
    eventBus.$onceOn(eventName, (newStatus) => {
        if (newStatus === COUPON_STATUS.STATUS_NEW) {
            giftInfo.status = COUPON_STATUS.STATUS_NEW;
            changeBtnText(getBtnTxt);
        } else if (newStatus === COUPON_STATUS.STATUS_RECEIVED) {
            giftInfo.status = COUPON_STATUS.STATUS_RECEIVED;
            changeBtnText(afterGetBtnText);
        }
    });
    const data = {
        value,
        threshold,
        title,
        subtitle,
        defaultBtnText: canReceive ? getBtnTxt : afterGetBtnText,
        btnID,
    };

    return createComponent(tpl, { style, data }, events);
};

RedBagAreaA.describe = describeRedBagAreaA;
RedBagAreaA.changeBtnText = changeBtnText;
export default RedBagAreaA;
